import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import QuoteComponent from "/components/core/boards-and-quotes-carousel/quote/quote-component";
import PictureComponent from "/components/core/picture/picture-component";
class BoardsCarouselItemComponent extends PureComponent {
    onClick() {
        const { index, onClick } = this.props;
        onClick(index);
    }
    shouldRenderQuote() {
        const { item } = this.props;
        const { personImage, personTitle, quoteText } = item;
        return personImage || personTitle || quoteText;
    }
    render() {
        const { index, url, borderColor, item, aboveTheFold } = this.props;
        const { mobileImageWidthRatio } = item;
        const screenRatios = {
            mobile: mobileImageWidthRatio
        };
        const renderQuote = this.shouldRenderQuote();
        return /*#__PURE__*/ _jsxs("div", {
            className: "board-carousel-item-component board-carousel-item",
            onClick: this.onClick,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "board-carousel-image-wrapper",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        className: "board-carousel-image",
                        src: url,
                        specificImageStyle: {
                            borderColor
                        },
                        screenRatios: screenRatios
                    })
                }),
                renderQuote && /*#__PURE__*/ _jsx(QuoteComponent, {
                    activeQuote: item,
                    aboveTheFold: aboveTheFold
                })
            ]
        }, index);
    }
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
}
export { BoardsCarouselItemComponent as default };
